/**
 * 动效预设 CSS 注入（Wave 4 R3 / T4.7 集成）。
 *
 * 单一来源：motion/export.ts 的 recipeToCss 为 MOTION_PRESETS（属性面板可选
 * 的动效预设）生成 @keyframes + 类规则，渲染时经 <MotionPresetStyles /> 注入
 * 一次到预览/运行时样式表。渲染器侧对 motionPreset 非 none 的组件调用
 * applyRecipe 产出 inline animation（entrance 类）或 className（交互类），
 * 与此处 CSS 配合播放。
 */
import { MOTION_PRESETS } from "@/lib/builder/motion/presets";
import { recipeToCss } from "@/lib/builder/motion/export";

/** 全部面板预设的 CSS 片段（@keyframes + .dp-motion-* 类规则）。 */
export const MOTION_PRESET_CSS = MOTION_PRESETS.map((preset) => recipeToCss(preset.recipe)).join("\n\n");

/**
 * 渲染 <style> 注入动效 CSS。放置于页面/运行时根节点，全应用生效一次。
 */
export function MotionPresetStyles() {
  return <style data-testid="motion-preset-styles">{MOTION_PRESET_CSS}</style>;
}
